<mat-dialog-content>
  <lemon-dialog-header>
    {{ 'lasku.koko-virhe-dialog.otsikko' | translate | async }}
  </lemon-dialog-header>

  <pre style="padding-left: 3em; padding-right: 3em">{{ data.viesti | json }}</pre>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-primary-button mat-dialog-close actionId="Peruuta (laskun koko virhe dialog)">{{ 'yleiset.peruuta' | translate | async }}</app-primary-button>
</mat-dialog-actions>
